<era-select-location-list-ui [locations]="locations()"
                             [location]="location()"
                             [brandId]="brandId()"
                             [route]="['/devices']"
                             placeholder="Pick a location"
                             placement="bottom-left"></era-select-location-list-ui>